import * as React from 'react';

import Personal from '../FerrariIcon/Personal';

import s from './ProgressBar.module.css';

export default function InactiveSection(props) {
  const {sectionName, order} = props;

  if (sectionName === order.getIn([3])) {
    return (
      <div className={s.PersonalWrapper}>
        <Personal color="#707070" className={s.PersonalIcon} />

        <div className={s.inactiveIconPersonal} />
      </div>
    );
  } else {
    return (
      <div>
        <span className={s.inactiveIcon} />
      </div>
    );
  }
}
